import { Text } from "@certn/cascadia";
import {
  ButtonGroup,
  BasicButton,
  Modal,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
} from "@certn/cascadia-react";
import { Trans } from "react-i18next";

export function LearnMoreModal() {
  return (
    <Modal testID="">
      <Dialog>
        {({ close }) => (
          <>
            <DialogHeader
              onClose={close}
              testID="skip-dbs-consent-modal-header"
            >
              <Trans>DBS Profile Number</Trans>
            </DialogHeader>
            <DialogContent testID="skip-dbs-consent-modal-content">
              <Text style="global/body-primary">
                <Trans>
                  If you have one, your DBS Profile Number is used by the DBS to
                  verify your identity, link your application to your online
                  account, and ensure consistency by reducing errors during the
                  process.
                </Trans>
              </Text>
              <br />
              <br />
              <Text style="global/body-primary">
                <Trans>
                  By providing your DBS Profile Number, you can easily track the
                  progress of your application and access your DBS certificate
                  once it has been issued.
                </Trans>
              </Text>
            </DialogContent>
            <DialogFooter testID="skip-dbs-consent-modal-footer">
              <ButtonGroup>
                <BasicButton
                  size="medium"
                  onPress={close}
                  testID="skip-dbs-consent-cancel-button"
                >
                  <Trans>Close</Trans>
                </BasicButton>
              </ButtonGroup>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
